import { DbRoleWithActions, HandlersProgramResponse, HandlersProjectResponse } from "../../app/athenaApiGen";

export interface Role {
    programId: string;
    projectId: string;
    roleName: string;
    roleType?: string;
    scope?: string;//'system' | 'program' | 'project';
    items?: Array<{
        roleName: string;
    }>;
    actions?: Array<{
        action: string;
        type: string;
        scope: string;
        description?: string;
    }>;
}
type UserRole = Partial<Exclude<Role, "roleType">>
export interface User {
    id?: string;
    userName?: string;
    userType?: string;
    userEmail?: string;
    roles?: Array<UserRole>;
    contact?: Contact
}
export interface Contact {
    address?: string;
    govEmail?: string;
    name?: string;
    organizationId?: string;
    personalPhone?: string;
    workEmail?: string;
    workPhone?: string;
}
export interface RoleSection {
  roleType: string;
  items: Role[];
}

export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';
export type UserRoleWithScopes = Array<{role: DbRoleWithActions, projects: Array<HandlersProjectResponse>, programs: Array<HandlersProgramResponse>}>;
